// extracted by mini-css-extract-plugin
module.exports = {"box":"GameCircleHorizontal_box_2o-FO","list":"GameCircleHorizontal_list_36_ri"};